import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { BrazilPipe } from 'app/pipes/brazil.pipe';
import { ParseFloatPipe } from 'app/pipes/parseFloat.pipe';

@NgModule({
  declarations:[FilterPipe, SearchPipe, ShortNamePipe, BrazilPipe, ParseFloatPipe],
  imports:[CommonModule],
  exports:[FilterPipe, SearchPipe, ShortNamePipe, BrazilPipe, ParseFloatPipe]
})

export class PipeModule{}
